import { render, staticRenderFns } from "./SemData.vue?vue&type=template&id=45f021e6&scoped=true&"
import script from "./SemData.vue?vue&type=script&lang=js&"
export * from "./SemData.vue?vue&type=script&lang=js&"
import style0 from "./SemData.vue?vue&type=style&index=0&id=45f021e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f021e6",
  null
  
)

export default component.exports